// extracted by mini-css-extract-plugin
export var background = "index-module--background--3SA0n";
export var galleryContainer = "index-module--galleryContainer--3H8Nx";
export var textContainer = "index-module--textContainer--Er4a-";
export var title = "index-module--title--18LcR";
export var text = "index-module--text--3b6kW";
export var arrow = "index-module--arrow--2O4kZ";
export var image = "index-module--image--G9zr2";
export var carousel = "index-module--carousel--ayIO7";